import {Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import {AbstractControl, FormControl, FormGroup} from "@angular/forms";
import {Subject, debounceTime, takeUntil} from 'rxjs';

@Component({
  selector: 'app-form-input-dropdown',
  templateUrl: './form-input-dropdown.component.html',
  styleUrls: ['./form-input-dropdown.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormInputDropdownComponent implements OnInit, OnDestroy {

  @Input() values: any[] | undefined | null = [];
  @Input() cssClasses? = '';
  @Input() selectedValue: string | number = '';
  @Input() name = '';
  @Input() label: string | undefined | null = '';
  @Input() placeholder: string | undefined = 'Bitte wählen Sie';
  @Input() toolTipMessage: string = '';
  @Input() htmlId: number = Math.floor(Math.random() * (1 + Math.random() * 1000));
  @Input() formName: FormGroup = new FormGroup({});
  @Input() control!: FormControl;
  @Input() type: string | null = 'Standard';
  @Input() dynamicFormSettings = false;
  @Input() required: boolean = false;
  @Input() readonly: boolean = false;

  private selectionChange$ = new Subject<void>();
  private destroy$ = new Subject<void>();
  showValidation = false;
  isDropdownOpen = false;

  public telPrefixes = [
    '+43',
    '+49',
    '+31',
    '+36',
    '+385',
    '+386',
    '+39',
    '+41',
    '+420',
    '+421',
    '+48',
  ];

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    if(this.dynamicFormSettings) {
      this.type = null; //disable standard
      
      // Transform product selection values if needed
      if (this.values && this.values.length > 0 && this.values[0].streitwertProduct) {
        this.values = this.values.map(item => ({
          value: item.streitwertProduct.id,
          option: item.streitwertProduct.name
        }));
      }
    
    }

    // Only set up subscriptions without modifying the control state
    if (this.control) {
      // Setup validation state changes
      this.control.statusChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          if (!this.isDropdownOpen) {
            this.showValidation = this.control.touched;
            this.cdr.markForCheck();
          }
        });

      // Setup debounced selection validation
      this.selectionChange$
        .pipe(
          debounceTime(300),
          takeUntil(this.destroy$)
        )
        .subscribe(() => {
          if (!this.isDropdownOpen) {
            this.showValidation = true;
            this.control?.updateValueAndValidity();
            this.cdr.markForCheck();
          }
        });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSelect() {
    // Prevent selection if readonly
    if (this.readonly === true) {
      return;
    }
    
    this.isDropdownOpen = true;
    this.selectionChange$.next();
    this.cdr.markForCheck();
  }

  onValueChange(event: any) {
    // Prevent value change if readonly
    if (this.readonly === true) {
      return;
    }
    
    const selectedValue = event.target.value;
    
    if (this.control) {
      this.control.setValue(selectedValue);
      this.control.markAsTouched();
      this.control.updateValueAndValidity();
      this.cdr.markForCheck();
    }
  }

  onDropdownClose() {
    this.isDropdownOpen = false;
    if (this.control) {
      this.showValidation = true;
      this.control.markAsTouched();
      this.control.updateValueAndValidity();
      this.cdr.markForCheck();
    }
  }

  onBlur() {
    // Prevent blur handling if readonly
    if (this.readonly === true) {
      return;
    }
    
    if (this.control && !this.isDropdownOpen) {
      this.showValidation = true;
      this.control.markAsTouched();
      this.control.updateValueAndValidity();
      this.cdr.markForCheck();
    }
  }
}

